/**
 * Internationalization (I18n) Module
 * Provides translation dictionaries and UI translation binding for global client and provider support.
 */

export const TRANSLATIONS = {
  en: {
    appName: "What To Eat?",
    tagline: "Find available meals from restaurants & caterers - 24/7",
    navClient: "For Clients",
    navProvider: "For Restaurants/Caterers",
    navAdmin: "Admin Panel",
    guestNotice: "Guest (Not logged in)",
    searchPlaceholder: "Search meals, cuisines, or providers...",
    allTypes: "All Types",
    breakfast: "Breakfast",
    lunch: "Lunch",
    dinner: "Dinner",
    dessert: "Dessert",
    drinks: "Drinks",
    snack: "Snack",
    filter247: "24/7 Available",
    filterSpecial: "Daily Specials",
    orderNow: "Place Order",
    price: "Price",
    tax: "Estimated Tax",
    total: "Total Amount",
    selectLanguage: "Language",
    subscriptionPlan: "Subscription Plan",
    providerPortal: "Provider Management Portal",
    checkoutSuccess: "Payment Successful!",
    checkoutCancel: "Payment Cancelled.",
    marketNotSupported: "This market is not supported yet.",
    supportedCountries: "Supported countries",
    timezoneLabel: "Local time zone",
    openNow: "Open now",
    closedNow: "Closed now",
    phoneValidation: "Phone number must use international format.",
    countryRestriction: "This country is currently restricted for launch."
  },
  es: {
    appName: "¿Qué Comer?",
    tagline: "Encuentra comidas disponibles de restaurantes y banquetes - 24/7",
    navClient: "Para Clientes",
    navProvider: "Para Restaurantes",
    navAdmin: "Panel Admin",
    guestNotice: "Invitado (Sin iniciar sesión)",
    searchPlaceholder: "Buscar comidas, cocinas o proveedores...",
    allTypes: "Todos los Tipos",
    breakfast: "Desayuno",
    lunch: "Almuerzo",
    dinner: "Cena",
    dessert: "Postre",
    drinks: "Bebidas",
    snack: "Apetitivo",
    filter247: "Disponible 24/7",
    filterSpecial: "Especiales del Día",
    orderNow: "Realizar Pedido",
    price: "Precio",
    tax: "Impuesto Estimado",
    total: "Monto Total",
    selectLanguage: "Idioma",
    subscriptionPlan: "Plan de Suscripción",
    providerPortal: "Portal de Gestión de Proveedores",
    checkoutSuccess: "¡Pago Exitoso!",
    checkoutCancel: "Pago Cancelado.",
    marketNotSupported: "Este mercado aún no es compatible.",
    supportedCountries: "Países admitidos",
    timezoneLabel: "Zona horaria local",
    openNow: "Abierto ahora",
    closedNow: "Cerrado ahora",
    phoneValidation: "El número de teléfono debe usar formato internacional.",
    countryRestriction: "Este país está restringido para el lanzamiento actual."
  },
  fr: {
    appName: "Que Manger?",
    tagline: "Trouvez des repas disponibles dans les restaurants et traiteurs - 24/7",
    navClient: "Pour les Clients",
    navProvider: "Pour les Restaurants",
    navAdmin: "Panneau d'Admin",
    guestNotice: "Invité (Non connecté)",
    searchPlaceholder: "Rechercher des repas, cuisines ou prestataires...",
    allTypes: "Tous les types",
    breakfast: "Petit Déjeuner",
    lunch: "Déjeuner",
    dinner: "Dîner",
    dessert: "Dessert",
    drinks: "Boissons",
    snack: "Encas",
    filter247: "Disponible 24/7",
    filterSpecial: "Spécialités du Jour",
    orderNow: "Passer la commande",
    price: "Prix",
    tax: "Taxe Estimée",
    total: "Montant Total",
    selectLanguage: "Langue",
    subscriptionPlan: "Plan d'Abonnement",
    providerPortal: "Portail de Gestion Prestataire",
    checkoutSuccess: "Paiement Réussi!",
    checkoutCancel: "Paiement Annulé.",
    marketNotSupported: "Ce marché n'est pas encore pris en charge.",
    supportedCountries: "Pays pris en charge",
    timezoneLabel: "Fuseau horaire local",
    openNow: "Ouvert maintenant",
    closedNow: "Fermé maintenant",
    phoneValidation: "Le numéro de téléphone doit utiliser le format international.",
    countryRestriction: "Ce pays est actuellement restreint pour le lancement."
  },
  de: {
    appName: "Was Essen?",
    tagline: "Finden Sie verfügbare Mahlzeiten von Restaurants & Caterern - 24/7",
    navClient: "Für Kunden",
    navProvider: "Für Restaurants",
    navAdmin: "Admin-Bereich",
    guestNotice: "Gast (Nicht angemeldet)",
    searchPlaceholder: "Mahlzeiten, Küchen oder Anbieter suchen...",
    allTypes: "Alle Typen",
    breakfast: "Frühstück",
    lunch: "Mittagessen",
    dinner: "Abendessen",
    dessert: "Dessert",
    drinks: "Getränke",
    snack: "Snack",
    filter247: "24/7 Verfügbar",
    filterSpecial: "Tagesangebote",
    orderNow: "Bestellung Aufgeben",
    price: "Preis",
    tax: "Geschätzte Steuer",
    total: "Gesamtbetrag",
    selectLanguage: "Sprache",
    subscriptionPlan: "Abonnement-Plan",
    providerPortal: "Anbieter-Verwaltungsportal",
    checkoutSuccess: "Zahlung Erfolgreich!",
    checkoutCancel: "Zahlung Abgebrochen.",
    marketNotSupported: "Dieser Markt wird noch nicht unterstützt.",
    supportedCountries: "Unterstützte Länder",
    timezoneLabel: "Lokale Zeitzone",
    openNow: "Jetzt geöffnet",
    closedNow: "Jetzt geschlossen",
    phoneValidation: "Die Telefonnummer muss im internationalen Format vorliegen.",
    countryRestriction: "Dieses Land ist für den aktuellen Launch derzeit eingeschränkt."
  },
  pt: {
    appName: "O Que Comer?",
    tagline: "Encontre refeições disponíveis de restaurantes e buffet - 24/7",
    navClient: "Para Clientes",
    navProvider: "Para Restaurantes",
    navAdmin: "Painel Admin",
    guestNotice: "Convidado (Não conectado)",
    searchPlaceholder: "Buscar refeições, culinária ou fornecedores...",
    allTypes: "Todos os Tipos",
    breakfast: "Café da Manhã",
    lunch: "Almoço",
    dinner: "Jantar",
    dessert: "Sobremesa",
    drinks: "Bebidas",
    snack: "Lanche",
    filter247: "Disponível 24/7",
    filterSpecial: "Especiais do Dia",
    orderNow: "Fazer Pedido",
    price: "Preço",
    tax: "Imposto Estimado",
    total: "Valor Total",
    selectLanguage: "Idioma",
    subscriptionPlan: "Plano de Assinatura",
    providerPortal: "Portal do Fornecedor",
    checkoutSuccess: "Pagamento Bem-sucedido!",
    checkoutCancel: "Pagamento Cancelado.",
    marketNotSupported: "Este mercado ainda não é suportado.",
    supportedCountries: "Países suportados",
    timezoneLabel: "Fuso horário local",
    openNow: "Aberto agora",
    closedNow: "Fechado agora",
    phoneValidation: "O número de telefone deve estar em formato internacional.",
    countryRestriction: "Este país está restrito ao lançamento atual."
  }
};

const TRANSLATION_ENHANCEMENTS = {
  en: {
    searchMeals: "Search Meals",
    findAvailableMeals: "Find Available Meals",
    allCountries: "All Countries",
    allProviders: "All Restaurants/Caterers",
    allAvailability: "All Availability",
    afterHoursFilter: "After Hours",
    afterHoursOnly: "After Hours Only",
    afterHoursOk: "After Hours OK",
    searchButton: "Search",
    searchInputPlaceholder: "Search for food or restaurant/caterer name...",
    clientSearchTitle: "Search for Meals",
    clientSearchSubtitle: "Find available meals from restaurants and caterers worldwide!",
    ingredientsAllergens: "Ingredients/Allergens",
    drinksLabel: "Drinks",
    availablePortions: "Available Portions",
    servingsLeft: "servings left",
    reviews: "reviews",
    verifiedProvider: "Verified Provider",
    prepSla: "Prep SLA",
    cancellationReliability: "Cancellation reliability",
    deliveryRadius: "Delivery radius",
    deliveryAndPickup: "Delivery & Pickup",
    deliveryOnly: "Delivery",
    pickupOnly: "Pickup Only",
    registerToViewDetails: "Register to view price, servings, open/closed status, ingredients, drinks, delivery/pickup options & order!",
    registerToViewMenuItem: "Register to view this menu item",
    registerSubtext: "Create a free account to see prices, descriptions, ingredients, photos, delivery options & order!"
  },
  es: {
    searchMeals: "Buscar comidas",
    findAvailableMeals: "Encuentra comidas disponibles",
    allCountries: "Todos los países",
    allProviders: "Todos los restaurantes/caterers",
    allAvailability: "Toda disponibilidad",
    afterHoursFilter: "Fuera de horario",
    afterHoursOnly: "Solo fuera de horario",
    afterHoursOk: "Fuera de horario disponible",
    searchButton: "Buscar",
    searchInputPlaceholder: "Busca comida o nombre de restaurante/caterer...",
    clientSearchTitle: "Buscar comidas",
    clientSearchSubtitle: "¡Encuentra comidas disponibles de restaurantes y caterers en todo el mundo!",
    ingredientsAllergens: "Ingredientes/Alérgenos",
    drinksLabel: "Bebidas",
    availablePortions: "Porciones disponibles",
    servingsLeft: "porciones disponibles",
    reviews: "reseñas",
    verifiedProvider: "Proveedor verificado",
    prepSla: "SLA de preparación",
    cancellationReliability: "Confiabilidad de cancelación",
    deliveryRadius: "Radio de entrega",
    deliveryAndPickup: "Entrega y recogida",
    deliveryOnly: "Entrega",
    pickupOnly: "Solo recogida",
    registerToViewDetails: "¡Regístrate para ver precio, porciones, estado abierto/cerrado, ingredientes, bebidas, opciones de entrega/recogida y pedir!",
    registerToViewMenuItem: "Regístrate para ver este elemento del menú",
    registerSubtext: "Crea una cuenta gratis para ver precios, descripciones, ingredientes, fotos, opciones de entrega y pedir."
  },
  fr: {
    searchMeals: "Rechercher des repas",
    findAvailableMeals: "Trouver des repas disponibles",
    allCountries: "Tous les pays",
    allProviders: "Tous les restaurants/traiteurs",
    allAvailability: "Toutes disponibilités",
    afterHoursFilter: "Hors horaires",
    afterHoursOnly: "Seulement hors horaires",
    afterHoursOk: "Hors horaires accepté",
    searchButton: "Rechercher",
    searchInputPlaceholder: "Rechercher un plat ou un restaurant/traiteur...",
    clientSearchTitle: "Rechercher des repas",
    clientSearchSubtitle: "Trouvez des repas disponibles de restaurants et traiteurs du monde entier !",
    ingredientsAllergens: "Ingrédients/Allergènes",
    drinksLabel: "Boissons",
    availablePortions: "Portions disponibles",
    servingsLeft: "portions restantes",
    reviews: "avis",
    verifiedProvider: "Prestataire vérifié",
    prepSla: "SLA de préparation",
    cancellationReliability: "Fiabilité d’annulation",
    deliveryRadius: "Rayon de livraison",
    deliveryAndPickup: "Livraison et retrait",
    deliveryOnly: "Livraison",
    pickupOnly: "Retrait uniquement",
    registerToViewDetails: "Inscrivez-vous pour voir le prix, les portions, le statut ouvert/fermé, les ingrédients, les boissons, les options de livraison/retrait et commander !",
    registerToViewMenuItem: "Inscrivez-vous pour voir cet article du menu",
    registerSubtext: "Créez un compte gratuit pour voir les prix, descriptions, ingrédients, photos, options de livraison et commander."
  },
  de: {
    searchMeals: "Mahlzeiten suchen",
    findAvailableMeals: "Verfugbare Mahlzeiten finden",
    allCountries: "Alle Länder",
    allProviders: "Alle Restaurants/Caterer",
    allAvailability: "Alle Verfügbarkeiten",
    afterHoursFilter: "Nach den Öffnungszeiten",
    afterHoursOnly: "Nur nach den Öffnungszeiten",
    afterHoursOk: "Nach den Öffnungszeiten verfügbar",
    searchButton: "Suchen",
    searchInputPlaceholder: "Nach Essen oder Restaurant/Caterer suchen...",
    clientSearchTitle: "Nach Mahlzeiten suchen",
    clientSearchSubtitle: "Finden Sie verfügbare Mahlzeiten von Restaurants und Caterern weltweit!",
    ingredientsAllergens: "Zutaten/Allergene",
    drinksLabel: "Getränke",
    availablePortions: "Verfügbare Portionen",
    servingsLeft: "Portionen verfügbar",
    reviews: "Bewertungen",
    verifiedProvider: "Verifizierter Anbieter",
    prepSla: "Zubereitungs-SLA",
    cancellationReliability: "Stornierungszuverlässigkeit",
    deliveryRadius: "Liefer-Radius",
    deliveryAndPickup: "Lieferung & Abholung",
    deliveryOnly: "Lieferung",
    pickupOnly: "Nur Abholung",
    registerToViewDetails: "Registrieren Sie sich, um Preis, Portionen, Offen/Geschlossen-Status, Zutaten, Getränke, Liefer-/Abholoptionen und Bestellung zu sehen!",
    registerToViewMenuItem: "Registrieren Sie sich, um diesen Menüpunkt zu sehen",
    registerSubtext: "Erstellen Sie ein kostenloses Konto, um Preise, Beschreibungen, Zutaten, Fotos, Lieferoptionen und Bestellungen zu sehen."
  },
  pt: {
    searchMeals: "Buscar refeições",
    findAvailableMeals: "Encontre refeições disponíveis",
    allCountries: "Todos os países",
    allProviders: "Todos os restaurantes/buffets",
    allAvailability: "Toda disponibilidade",
    afterHoursFilter: "Fora do horário",
    afterHoursOnly: "Somente fora do horário",
    afterHoursOk: "Fora do horário disponível",
    searchButton: "Buscar",
    searchInputPlaceholder: "Busque por comida ou nome do restaurante/buffet...",
    clientSearchTitle: "Buscar refeições",
    clientSearchSubtitle: "Encontre refeições disponíveis de restaurantes e buffets no mundo todo!",
    ingredientsAllergens: "Ingredientes/Alergênicos",
    drinksLabel: "Bebidas",
    availablePortions: "Porções disponíveis",
    servingsLeft: "porções disponíveis",
    reviews: "avaliações",
    verifiedProvider: "Fornecedor verificado",
    prepSla: "SLA de preparo",
    cancellationReliability: "Confiabilidade de cancelamento",
    deliveryRadius: "Raio de entrega",
    deliveryAndPickup: "Entrega e retirada",
    deliveryOnly: "Entrega",
    pickupOnly: "Somente retirada",
    registerToViewDetails: "Cadastre-se para ver preço, porções, status aberto/fechado, ingredientes, bebidas, opções de entrega/retirada e pedir!",
    registerToViewMenuItem: "Cadastre-se para ver este item do cardápio",
    registerSubtext: "Crie uma conta gratuita para ver preços, descrições, ingredientes, fotos, opções de entrega e pedir."
  }
};

Object.keys(TRANSLATION_ENHANCEMENTS).forEach((langCode) => {
  if (!TRANSLATIONS[langCode]) return;
  Object.assign(TRANSLATIONS[langCode], TRANSLATION_ENHANCEMENTS[langCode]);
});

export class I18nService {
  constructor(defaultLang = "en") {
    this.currentLanguage = defaultLang;
  }

  setLanguage(langCode) {
    if (TRANSLATIONS[langCode]) {
      this.currentLanguage = langCode;
      this.applyTranslations();
      if (typeof window !== "undefined" && typeof CustomEvent !== "undefined") {
        window.dispatchEvent(new CustomEvent("languageChanged", { detail: { language: langCode } }));
      }
    }
  }

  getLanguage() {
    return this.currentLanguage;
  }

  getSupportedLanguages() {
    return [
      { code: "en", name: "English" },
      { code: "es", name: "Español" },
      { code: "fr", name: "Français" },
      { code: "de", name: "Deutsch" },
      { code: "pt", name: "Português" }
    ];
  }

  t(key, fallback = "") {
    const dict = TRANSLATIONS[this.currentLanguage] || TRANSLATIONS.en;
    return dict[key] || TRANSLATIONS.en[key] || fallback || key;
  }

  applyTranslations() {
    if (typeof document === "undefined") return;
    const elements = document.querySelectorAll("[data-i18n]");
    elements.forEach((el) => {
      const key = el.getAttribute("data-i18n");
      const translation = this.t(key);
      if (translation) {
        if (el.tagName === "INPUT" || el.tagName === "TEXTAREA") {
          if (el.hasAttribute("placeholder")) {
            el.placeholder = translation;
          }
        } else {
          el.textContent = translation;
        }
      }
    });
  }
}

export const i18nService = new I18nService();
